import { connect } from 'react-redux';
import CapPoints from './CapPoints';
import { getAnnualResults } from '../selectors';

import { setSelectedFinancing } from '../../../../common/settings/actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    capTerm: state.cap.capTerm,
    capDownPayment: state.cap.capDownPayment,
    downPayment: state.loan.downPayment,
    cashprice: state.solar.cashprice,
    systemSize: state.solar.systemSize,
    formattedSystemPrice: state.solar.systemSize,
    provider: state.utility.provider,
    annualInflation: state.utility.annualInflation,
    setSelectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    taxEntity: state.tax.taxEntity,
    projectState: state.projectaddress.projectState,
    sgipToggle: state.sgip.sgipToggle,
    includeESS: state.ess.includeESS,
    essPrice: state.ess.essPrice,
    resiToggle: state.tax.resiToggle,
    taxRate: state.tax.taxRate,
    projectName: state.projectaddress.projectName,
});

const combinedActions = {
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(CapPoints);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/CapPoints/index.js